import QuoteCaptionBlock from 'medium-draft/lib/components/blocks/blockquotecaption';
import CaptionBlock from 'medium-draft/lib/components/blocks/caption';
import AtomicBlock from 'medium-draft/lib/components/blocks/atomic';
import TodoBlock from 'medium-draft/lib/components/blocks/todo';
import BreakBlock from 'medium-draft/lib/components/blocks/break';
import { Block } from 'medium-draft/lib/util/constants';
import ImageBlock from './image';
export default (function (setEditorState, getEditorState) {
  return function (contentBlock) {
    var type = contentBlock.getType();
    switch (type) {
      case Block.BLOCKQUOTE_CAPTION:
        return {
          component: QuoteCaptionBlock
        };
      case Block.CAPTION:
        return {
          component: CaptionBlock
        };
      case Block.ATOMIC:
        return {
          component: AtomicBlock,
          editable: false,
          props: {
            getEditorState: getEditorState
          }
        };
      case Block.TODO:
        return {
          component: TodoBlock,
          props: {
            setEditorState: setEditorState,
            getEditorState: getEditorState
          }
        };
      case Block.IMAGE:
        return {
          component: ImageBlock,
          props: {
            setEditorState: setEditorState,
            getEditorState: getEditorState
          }
        };
      case Block.BREAK:
        return {
          component: BreakBlock,
          editable: false
        };
      default:
        return null;
    }
  };
});